import { __awaiter } from '../../../_virtual/_tslib.js';
import { OAuthExtension } from '@magic-ext/oauth';
import { logger } from '@dynamic-labs/wallet-connector-core';

const createMagicSocialWalletConnector = (MagicWalletConnector) => class MagicSocialWalletConnector extends MagicWalletConnector {
    constructor(opts) {
        super(opts);
        this.name = 'Magic Social';
        this.canConnectViaSocial = true;
        this.magicClient.use(new OAuthExtension());
    }
    connect(provider) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loginWithMagic({ provider });
        });
    }
    loginWithMagic(options) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!options.provider) {
                logger.warn('loginWithMagic called without a provider, returning early');
                return null;
            }
            const client = this.magicClient.getClient();
            if (yield client.user.isLoggedIn()) {
                return (yield client.user.getInfo()).publicAddress;
            }
            yield client.oauth.loginWithRedirect({
                provider: options.provider,
                redirectURI: window.location.href,
            });
            return null;
        });
    }
    getSession() {
        return __awaiter(this, void 0, void 0, function* () {
            const client = this.magicClient.getClient();
            try {
                const result = yield client.oauth.getRedirectResult();
                const { publicAddress } = result.magic.userMetadata;
                if (publicAddress) {
                    localStorage.setItem(this.storedAddressKey, publicAddress);
                }
                return Object.assign(Object.assign({}, result.oauth), { didToken: result.magic.idToken, oauthId: result.oauth.userInfo.sub });
            }
            catch (e) {
                logger.error(e);
                return undefined;
            }
        });
    }
};

export { createMagicSocialWalletConnector };
